<div class="container-fluid ">
    <div class="row mt-5" >
        <div class="col-md-6 bgImage text-white">
            <div class="m-5">
                <h3 class="mt-5"> {{contactData?.flatData?.pageTitle}} </h3>
                <form class="mt-5"  [formGroup]="contactForm" >
                    <div class="mb-3">
                        <label class="label mb-1">الإسم</label>
                        <input class="input" style="width: 490px;
                        
                        height: 45px;
                        gap: 0px;
                        border: 0;
                        border-radius: 6px;
                        opacity: 0px;
                        "
                        formControlName="name"
                        >
                    </div>
                    <div class="mb-3">
                        <label class="label mb-1">البريد الالكتروني</label>
                        <input class="input" style="width: 490px;
                        height: 45px;
                        gap: 0px;
                        border: 0;
                        border-radius: 6px;
                        opacity: 0px;
                        "
                        formControlName="email"
                        >
                    </div>
                    <div class="mb-3">
                        <label class="label mb-1"> نص الرسالة</label>
                        <textarea class="input" style="
                        height: 189px;
                        width: 100%;
                        gap: 0px;
                        border: 0;
                        border-radius: 6px;
                        opacity: 0px;
                        "
                        formControlName="message"
                        ></textarea>
                    </div>
                    <button class="btn btn-primary" [disabled]="(contactForm.get('email')?.valid)" (click)="sendform() ">ارسال</button>
                </form>
            </div>
        </div>
        <div class="col-md-6 ">


            <google-map  [options]="options">

            <map-marker

  [position]="options.center"></map-marker>
        
            </google-map>
            <!-- <iframe style="
            border:0;
            width: 574px;
            height: 571px;
            top: 559px;
            left: 130px;
            gap: 0px;
            border-radius: 6px ;
            opacity: 0px;
            " src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1488573.7594402747!2d28.91223210387454!3d29.93727676412713!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x145840f757e1bd4f%3A0x1b5b2458665b3481!2sEgyptian%20Center%20For%20Economic%20Studies%20-%20ECES!5e0!3m2!1sen!2seg!4v1729672577792!5m2!1sen!2seg"
                allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
            </iframe> -->
            <div class="row mt-2">
                <div class="col-6 d-flex  align-items-end">
                    <p style="
                    font-family: Noto Kufi Arabic;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 30.35px;
                    text-align: right;">حسابتنا علي السوشيال ميديا</p>
                </div>
                <div class="col-6  d-flex justify-content-end align-items-center ">           

                    <span class="ms-3" *ngFor="let item of contactData?.flatData?.ourSocialMedia">
                      <a class="link-dark" [href]="item?.value">
                        <img [src]="item?.type[0]?.flatData?.mainLogo[0]?.url">
                      </a>
                    </span>
 
                </div>
            </div>
        </div>
    </div>
</div>



<!-- <ng-template #standardTpl> I'm a standard toast </ng-template> -->

<!-- <app-toasts aria-live="polite" aria-atomic="true"></app-toasts> -->